"use client";

import * as React from "react";
import {
  Switch as ReactSwitch,
  RouteComponentProps,
  withRouter,
} from "react-router-dom";

import { removeLocaleFromUrl } from "./util";

const SwitchBase = (props: RouteComponentProps) => {
  const { location, ...otherProps } = props;
  const newLocation = {
    ...location,
    pathname: removeLocaleFromUrl(location.pathname),
  };
  return <ReactSwitch location={newLocation} {...otherProps} />;
};

export const Switch = withRouter(SwitchBase);
